module.exports = __webpack_public_path__ + "static/media/git-square.add29e5a.svg";